import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import paintings from '../data/paintings.json';

export default function PaintingDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const painting = paintings[parseInt(id)];

    if (!painting) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-gray-900 mb-4">Peinture non trouvée</h1>
                    <button 
                        onClick={() => navigate('/')}
                        className="btn-artist inline-block rounded-full"
                    >
                        Retour à l'accueil
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen py-12 px-4">
            <div className="max-w-7xl mx-auto">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-gray-700 hover:text-orange-500 transition-colors mb-8 group"
                >
                    <ChevronLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
                    Retour
                </button>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
                    {/* Image */}
                    <div className="group">
                        <div className="relative overflow-hidden rounded-lg shadow-2xl">
                            <img
                                src={`./images/${painting.img}`}
                                alt={painting.name}
                                className="w-full h-auto object-cover"
                            />
                            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                                style={{
                                    background: 'radial-gradient(circle at 30% 30%, rgba(255, 140, 66, 0.3) 0%, transparent 50%)',
                                }}
                            />
                        </div>
                    </div>

                    <div className="flex flex-col justify-start space-y-8">
                        <div>
                            <div className="flex items-center gap-3 mb-4">
                                <span className="inline-block px-3 py-1 bg-orange-500 text-white text-sm font-semibold rounded-full">
                                    {painting.type}
                                </span>
                            </div>
                            <h1 className="text-5xl font-bold text-gray-900 mb-2">
                                {painting.name}
                            </h1>
                            <p className="text-xl text-gray-600 italic">
                                {painting.year}
                            </p>
                        </div>

                        <div className="space-y-6 border-t border-gray-200 pt-6">
                            <div>
                                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                                    Dimensions
                                </h3>
                                <p className="text-lg text-gray-900 font-medium">
                                    {painting.dimensions}
                                </p>
                            </div>

                            <div>
                                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                                    Description
                                </h3>
                                <p className="text-gray-700 leading-relaxed text-lg">
                                    {painting.description}
                                </p>
                            </div>
                        </div>

                        <div className="pt-6 border-t border-gray-200">
                            <button className="btn-artist inline-block rounded-full">
                                Contacter pour plus d'infos
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
